import useSWRImmutable from 'swr/immutable'

import { isLiveChatApp } from '../reduxes/slices/live_chat_app/selectors'
import { useSelectorDelegateStore } from '../reduxes/stores/root_store/hooks'

// This is served from the /public directory
const EMOJI_DATA_URL = '/apple.json'

const fetcher = (url: string) => fetch(url).then((res) => res.json())

export const useFetchEmojiData = () => {
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)

  return useSWRImmutable(
    liveChatApp
      ? // eslint-disable-next-line
        // @ts-ignore
        window.speakeasySettings.apiBase + EMOJI_DATA_URL
      : EMOJI_DATA_URL,
    fetcher,
  )
}
